import { FC } from 'react';

import { useBreakpoints } from '@phoenix/design-system/frontend/ui/breakpoints/use-breakpoints';

import { ProductRecommendedCard, ProductRecommendedCardProps } from '../product-recommendation/product-recommended-card';
import { CompatiblePlaceholderCard } from './compatible-placeholder-card';

export const CompatibleProductsWithPlaceholders: FC<{ products: Omit<ProductRecommendedCardProps, 'index'>[] }> = ({ products }) => {
  const { tablet, desktop } = useBreakpoints();

  return (
    <div className="grid gap-6 py-6 tablet:grid-cols-2 desktop:grid-cols-3">
      {((tablet && products.length === 1) || (desktop && products.length < 3)) && <CompatiblePlaceholderCard imageSrc="backyard.jpeg" />}
      {products.map((product, i) => (
        <ProductRecommendedCard key={product.articleNumber} {...product} index={i + 1} />
      ))}
      {desktop && products.length === 1 && <CompatiblePlaceholderCard imageSrc="home-worker.jpeg" />}
    </div>
  );
};
